export default "__VITE_ASSET__CpJfFhPS__"